import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@UI/components/Toast';
import AppRoutes from './routes/AppRoutes';
import './shared/i18n/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    },
    mutations: {
      retry: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="bottom-right" duration={4000} richColors />
      <AppRoutes />
    </QueryClientProvider>
  );
}

export default App;
